module.exports = __webpack_public_path__ + "img/02-Eisai-แบบสอบถาม.36c94b0a.png";